/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RfpDraftsControllerRfpQueryResponse, RfpDraftsControllerRfpPathParams, RfpDraftsControllerRfp400, RfpDraftsControllerRfp401, RfpDraftsControllerRfp403, RfpDraftsControllerRfp404 } from "../../models/rfpDraftsController/RfpDraftsControllerRfp";

function getRfpDraftsControllerRfpUrl(id: RfpDraftsControllerRfpPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/document-drafts/rfp/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/rfp/:id}
 */
export async function rfpDraftsControllerRfp(id: RfpDraftsControllerRfpPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RfpDraftsControllerRfpQueryResponse, ResponseErrorConfig<RfpDraftsControllerRfp400 | RfpDraftsControllerRfp401 | RfpDraftsControllerRfp403 | RfpDraftsControllerRfp404>, unknown>({ method : "GET", url : getRfpDraftsControllerRfpUrl(id).url.toString(), ... requestConfig })  
  return res.data
}